// extracted by mini-css-extract-plugin
export var formContainer = "_ee-0";
export var message = "_ee-1";